import {TitleGreenSpanSecond} from "@components/title/title-green-span-second";
import {FC} from "react";
import {i18translateType, PagePropsBasicType} from "../../../../@types/types-body";
import {BoxServiceCardIconTopBox} from "@components/boxes/box-service-card-icon-top-box";
import {MobileCardIconsEnum,} from "@data/services-box-icons/mobile-card-icons-enum";
import CrossNative from "@images/services/crossvsnative.webp";
import {useTranslation} from "next-i18next";
import Image from "next/image";

const MobileWhyUsSection: FC<PagePropsBasicType> = ({namespace}) => {
    const {t}: i18translateType = useTranslation(namespace);
    return (<section className="my-24" id="section-why-us-mobile">
        <div className="container mx-auto">
            <TitleGreenSpanSecond
                id="section-why-us-mobile-title"
                namespace={namespace}
                title="section_why_us.title"
                span="section_why_us.span"
                description="section_why_us.description"
            />
        </div>
        <div className="w-full justify-center text-center align-middle">
            <div className={"grid grid-cols-1 lg:gap-8 lg:grid-cols-2 mt-5 mb-2"}>
                <div className="w-full">
                    <Image src={CrossNative} alt={t(`section_why_us.title`)}/>
                </div>
                <ul className="list-disc list-inside text-justify space-y-2 px-4">
                    <li><span
                        className="font-bold">{t('section_why_us.intro.one.span')}</span>{t('section_why_us.intro.one.text')}
                    </li>
                    <li><span
                        className="font-bold">{t('section_why_us.intro.two.span')}</span>{t('section_why_us.intro.two.text')}
                    </li>
                    <li><span
                        className="font-bold">{t('section_why_us.intro.three.span')}</span>{t('section_why_us.intro.three.text')}
                    </li>
                    <li><span
                        className="font-bold">{t('section_why_us.intro.four.span')}</span>{t('section_why_us.intro.four.text')}
                    </li>
                    <li><span
                        className="font-bold">{t('section_why_us.intro.five.span')}</span>{t('section_why_us.intro.five.text')}
                    </li>
                </ul>
            </div>
        </div>
        <div className="w-full justify-center text-center align-middle">
            <div className="w-full crowlyn-divider-up text-center h-20 -mb-8 mt-0 overflow-y-scroll bg-cover bg-fixed bg-center bg-no-repeat shadow-lg
                bg-[url('/images/banners/versus.webp')]">
            </div>
            <h3 className="text-crowlyn-night font-extrabold text-base lg:text-4xl m-0 p-0">Native vs
                Cross-Platform</h3>
            <div className="w-full crowlyn-divider-down text-center h-20 -mt-7 overflow-y-scroll bg-cover bg-fixed bg-center bg-no-repeat shadow-lg
                bg-[url('/images/banners/versus.webp')]">
            </div>
        </div>
        <div className="container mx-auto mt-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 text-justify gap-12 mx-4 lg:mx-0">
                <div className="col-span-1 flex flex-col space-y-5">
                    <h4 className="font-bold text-center text-2xl">{t('section_why_us.native_development_title')}</h4>
                    <p>{t('section_why_us.native_development')}</p>
                </div>
                <div className="col-span-1 flex flex-col space-y-5">
                    <h4 className="font-bold text-center text-2xl">{t('section_why_us.cross_platform_development_title')}</h4>
                    <p>{t('section_why_us.cross_platform_development')}</p>
                </div>
            </div>
            <div className="flex flex-row flex-wrap space-x-4 justify-around mx-auto mt-6">
                <BoxServiceCardIconTopBox
                    id="section-why-us-mobile-cards"
                    key="section-why-us-mobile-cards"
                    namespace={namespace}
                    object={"section_why_us.native_card"}
                    iconEnum={MobileCardIconsEnum}
                />
            </div>
        </div>
    </section>)

};

export default MobileWhyUsSection;
